//import { Button } from "@material-tailwind/react";
import { useState } from "react";
import { useDataApi as useDataSpacesApi } from "../../Hooks/useDataSpacesApi";
import { useDataApi as useDataReservationsApi } from "../../Hooks/useDataReservationApi";
import { useDataApi as useDataUsersApi } from "../../Hooks/useDataUsersApi";
import { dateToTimestamp, getDayTwoLine, getSunday, getWeek, isHourLimit, isOld } from "../../utils/time/time";
import "./week.css";
import { Reservation as ReservationAPI, IReservationDay } from "../../services/coworkerApiCalls/Reservations/ReservationsTypes";
import { getDailyReservations } from "../../services/coworkerApiCalls/Reservations/ReservationsJour";
import { useDataApiArticles } from "../../Hooks/useDataArticlesApi";
import { useOktaAuth } from "@okta/okta-react";
import { Person } from "../person/person";
import { ArticleCard } from "../article/article";
import { faClock, faUserMinus, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createReservation, deleteReservation } from "../../services/coworkerApiCalls/Reservations/Reservations";
import { useDataApiSettingByName } from "../../Hooks/useDataSettingsApi";
import { ID_SPACE } from "../../constant";
/**
 * @function Week displays the complete week for the reservation page
 * @returns {JSX.Element} HTML content
 */
function Week(): JSX.Element {
  const [weekNumber, setWeekNumber] = useState(0);

  const date: Date = new Date();
  date.setDate(date.getDate() + 7 * weekNumber);
  const sunday: Date = getSunday(date);

  const { authState } = useOktaAuth();
  const oktaUid = authState!.idToken!.claims.sub;
  const spacesReservation = useDataSpacesApi();
  const userReservation = useDataUsersApi();
  const numberOfReservations = useDataApiSettingByName("numberOfReservations") ?? "0";
  const coworkerHourLimit = useDataApiSettingByName("coworkerHourLimit") ?? "0";

  const quotaReservation: number | undefined = spacesReservation?.quotas.find(q => q.departmentId === userReservation?.idDepartment)?.value;
  const quotaTotalMax: number | undefined = spacesReservation?.quotas.reduce((accumulator, current) => accumulator + current.value, 0);
  
  //get starting date of the week
  const startDate: Date = new Date(sunday);
  startDate.setDate(startDate.getDate() + 1);
  startDate.setHours(0, 0, 0, 0);

  //get ending date of the week
  const endDate: Date = new Date(startDate);
  endDate.setDate(endDate.getDate() + 6);
  endDate.setHours(23, 59, 59, 59);

  const timestampStartDate: number = dateToTimestamp(startDate);
  const timestampEndDate: number = dateToTimestamp(endDate);

  const [refreshKey, setRefreshKey] = useState(0);
  const reservations: ReservationAPI[] = useDataReservationsApi(timestampStartDate, timestampEndDate, refreshKey);

  const refreshReservations = () => {
    setRefreshKey(oldKey => oldKey + 1);
  };

  const articles = useDataApiArticles();
  const dailyReservations: IReservationDay[] = getDailyReservations(reservations, timestampStartDate, quotaReservation, quotaTotalMax, articles!, numberOfReservations, coworkerHourLimit);
  
  //searching if current user have a reservation in the current week
  let find: number = 0;
  for (const reservationDay of dailyReservations) {
    for (const reservation of reservationDay.Reservations) {
      if (reservation.user.oktaUid === oktaUid) {
        find++;
      }
    }
    for (const reservation of reservationDay.WaitingList) {
      if (reservation.user.oktaUid === oktaUid) {
        find++;
      }
    }
  }

  // Calculer le nombre total d'articles
  const totalArticles = dailyReservations.reduce((accumulator, reservationDay) => {
    return accumulator + reservationDay.Articles.length;
  }, 0);

  // eslint-disable-next-line unicorn/consistent-function-scoping, @typescript-eslint/no-explicit-any
  const calculateDateFind = (dailyReservationTest: { Reservations: any; date: any; WaitingList: any; }, oktaUidTest: any) => {
    for (const reservationcc of dailyReservationTest.Reservations) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (reservationcc.user.oktaUid === oktaUidTest) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return dailyReservationTest.date;
      }
    }
    for (const waitingcc of dailyReservationTest.WaitingList) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (waitingcc.user.oktaUid === oktaUidTest) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return dailyReservationTest.date;
      }
    }
    return 0;
  };


  // eslint-disable-next-line @typescript-eslint/no-shadow, @typescript-eslint/no-explicit-any, unicorn/consistent-function-scoping
  const countPlaceWaitingList = (dailyReservation: { WaitingList: { user: { oktaUid: any; }; }[]; }, oktaUid: any) => {
    let waitingIndex = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, unicorn/no-array-for-each
    dailyReservation.WaitingList.forEach((waiting: { user: { oktaUid: any; }; }, index: number) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (waiting.user.oktaUid === oktaUid) {
        waitingIndex = index + 1;
      }
    });
    return waitingIndex;
  };

  // eslint-disable-next-line unicorn/consistent-function-scoping
  async function buttonCreateReservation(token: string, dayDate: number) {
    const reservationTimestamp: number = dayDate * 1000;
    const idSpace = ID_SPACE;
    await createReservation(token, idSpace, reservationTimestamp)
  }

  // eslint-disable-next-line unicorn/consistent-function-scoping
  async function buttonDeleteReservation(token: string, dayDate: number) {
    const reservationTimestamp: number = dayDate * 1000;
    const idSpace = ID_SPACE;
    await deleteReservation(token, idSpace, reservationTimestamp)
  }
  return (

    <div className="flex flex-col bg-white rootHome min-h-screen">
      {/* Display the week navigator (to the left) */}
      <div className="flex justify-between items-center bg-light-gray week font-semibold">
        {getWeek(date) > getWeek(new Date()) ? (
          <button onClick={() => { setWeekNumber(weekNumber - 1); refreshReservations(); }}>
            <span className="material-icons weekArrow align-middle">
              arrow_left
            </span>
          </button>
        ) : (
          <span className="material-icons weekArrow align-middle">&nbsp;&nbsp;&nbsp;&nbsp;</span>
        )}

        {/* Display the week number */}
        <h1 className="align-middle font-bold text-xl">Semaine {getWeek(date)}</h1>

        {/* Display the week navigator (to the right) */}
        <div className="flex items-center mr-2">
          {getWeek(date) < getWeek(new Date()) + 1 ? (
            <button onClick={() => { setWeekNumber(weekNumber + 1); refreshReservations(); }}>
              <span className="material-icons weekArrow align-middle">
                arrow_right
              </span>
            </button>
          ) : (
            <span className="material-icons weekArrow align-middle">&nbsp;&nbsp;&nbsp;&nbsp;</span>
          )}

        </div>
      </div>

      {/* Display Each days */}
      <div className="w-full flex flex-col items-center space-y-4">
        
        <div className="w-full grid grid-cols-1 lg:grid-cols-5 gap-4">
          {/* Display Reservation */}
          {dailyReservations.map((dailyReservation, index) => (
            <div key={index} className="flex flex-col items-center border p-4">
              <div className="flex flex-col items-center mb-4">
                <h2 className="text-lg font-bold flex flex-col items-center text-center">
                  {/* Display day name */}
                  <div className="flex flex-row items-center justify-center">
                    {getDayTwoLine(dailyReservation.date, dailyReservation.dayName)}
                  </div>
                  {/* Display quota */}
                  <div className="mt-1">
                    {dailyReservation.quota !== undefined && (
                      <span
                        className={`
            ${dailyReservation.Reservations.length === dailyReservation.quota ? 'bg-red-500 text-white' : ''} 
            ${dailyReservation.Reservations.length < dailyReservation.quota ? 'bg-gray-300 text-black' : ''}
            px-2 py-1 rounded text-sm`}
                      >
                        {dailyReservation.Reservations.length}/{dailyReservation.quota}
                      </span>
                    )}
                  </div>
                </h2>
              </div>

              {/* Display Members */}
              <div className="w-full flex-grow">
                <div className="flex flex-col space-y-2">

                  {/*eslint-disable-next-line unicorn/prevent-abbreviations*/}
                  {dailyReservation.Reservations.map((reservation, resIndex) => (
                    <Person key={resIndex} user={reservation.user} dayDate={dailyReservation.date} refreshReservations={refreshReservations} />
                  ))}
                </div>
              </div>

              {/* Display buttons */}
              <div className="2xl:mt-4 mt-6 w-full">
                <div className="flex justify-between items-center h-10">
                  {/*
                   * isOld(date) -> function returning boolean to see if the date is after or before today
                   * isHourLimit(coworkerHourLimit, date) -> return boolean checking the hour in base with the date set
                   * dailyReservation.quota -> quota of places for the department of the current user
                   * quotaTotalMax -> quota for all department
                   * dailyReservation.Reservations.length -> numbers of reservations in a day
                   * find -> counter of how many reservation you have in the current week
                   * Number.parseInt(numberOfReservations!.value) -> maximum reservations of a person set in the database
                   * a reservation at the day
                   * calculateDateFind() -> function returning boolean to see if you have a reservation ona specific day
                   * dailyReservation.date -> day of the week
                   * */}
                  {dailyReservation.quota === undefined ?
                    <div
                      className="animate-pulse bg-gray-300 disabled text-md font-semibold border p-5 rounded">
                    </div> : (
                      <>
                        {/*
                        - isOld                                       : si la date du jour voulu est antérieur à la date actuelle
                        - calculateDateFind === dailyReservation.date : si il y a une reservation ce jour
                        - find < 4                                    : si le nombre total de reservation < 4 (valeur définie par le DSI)
                        - isHourLimit                                 : si l'heure limite est dépassée (valeur en base de données)
                        - isInternal                                  : si l'utilisateur actuel est interne
                        
                        (A==B)∣∣(C<D) <> !((A !== B) && (C >= D))
                        !(calculateDateFind(dailyReservation, oktaUid) !== dailyReservation.date && (find >= 4)) 
                        (((calculateDateFind(dailyReservation, oktaUid) === dailyReservation.date) || (find < 4))
                        
                      */}
                        {((!isOld(dailyReservation.date) && ((calculateDateFind(dailyReservation, oktaUid) === dailyReservation.date) || (find < 4)) && ((isHourLimit(coworkerHourLimit, dailyReservation.date - 86_400) && !userReservation?.isInternal) || userReservation?.isInternal)))
                          ? (
                            <>
                              {/*
                                - calculateDateFind === dailyReservation.date : si il y a une reservation ce jour
                              */}
                              {(calculateDateFind(dailyReservation, oktaUid) === dailyReservation.date) ? (
                                <>
                                  <button
                                    className={
                                      'bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded w-full'
                                    }
                                    type="button"
                                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                                    onClick={async () => {
                                      await buttonDeleteReservation(authState!.idToken!.idToken, dailyReservation.date);
                                      refreshReservations();
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faUserMinus} />
                                  </button>
                                </>

                              ) : (
                                <>
                                  {/*
                                    - quotaDep > daily.Reservation.length  : si le nombre de reservation est inférieur au quota Departemental défini
                                    - find < numberofReservationsMax       : si le nombre de réservation dans la semaine de l'utilisateur est < au nombre de reservations défini en paramètre
                                  */}
                                  <button
                                    className={
                                      (dailyReservation.quota > dailyReservation.Reservations.length) && ((find < Number.parseInt(numberOfReservations)) || isHourLimit(coworkerHourLimit, dailyReservation.date - 86_400))
                                        ? 'bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded w-full'
                                        : 'bg-orange-500 hover:bg-orange-600 text-white py-2 px-4 rounded  w-full'
                                    }

                                    type="button"
                                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                                    onClick={async () => {
                                      await buttonCreateReservation(authState!.idToken!.idToken, dailyReservation.date);
                                      refreshReservations();
                                    }}
                                  >

                                    {(dailyReservation.quota > dailyReservation.Reservations.length) && ((find < Number.parseInt(numberOfReservations)) || isHourLimit(coworkerHourLimit, dailyReservation.date - 86_400))
                                      ? (<><FontAwesomeIcon icon={faUserPlus} /></>)
                                      : (<><FontAwesomeIcon icon={faClock} /></>)
                                    }
                                  </button>

                                </>
                              )}

                            </>
                          )
                          :
                          (<>
                            <button
                              className={'bg-gray-500 text-dark cursor-no-drop py-2 px-4 rounded w-full'}
                              type="button"
                              disabled>
                              <FontAwesomeIcon icon={faUserPlus} />
                            </button>
                          </>)}
                      </>)
                  }
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Waiting List Column */}
        <div className="w-full grid grid-cols-1 lg:grid-cols-5 gap-4 lg:grid hidden">
          {dailyReservations.map((dailyReservation, index) => (
            <>
              {dailyReservation.WaitingList.length > 0 ?
                <div key={index} className="flex flex-col items-center border p-4">
                  <div className="w-full flex justify-between items-center mb-4">
                    <h3 className="text-md font-semibold">File d'attente</h3>
                    <p>{dailyReservation.WaitingList.length}</p>
                  </div>
                  {countPlaceWaitingList(dailyReservation, oktaUid) ?
                    <div className="w-full flex justify-between items-center mb-4">
                      <h3 className="text-md font-semibold">Place dans la file</h3>
                      <p>{countPlaceWaitingList(dailyReservation, oktaUid)}</p>
                    </div>
                    :
                    <></>
                  }

                </div>
                :
                <>
                  <div className="w-full flex justify-between items-center mb-4">

                  </div>
                </>
              }
            </>
          ))}
        </div>


        {/* News Column */}
        {totalArticles > 0 &&
          <div className="w-full flex items-left lg:block hidden">
            <h3 className="font-bold text-xl">News <hr /> </h3>
          </div>
        }

        <div className="w-full grid grid-cols-1 lg:grid-cols-5 gap-4 lg:grid hidden">

          {dailyReservations.map((dailyReservation, index) => (
            <div key={index} className="flex flex-col items-center p-4">
              <div className="w-full flex flex-wrap justify-start gap-2 lg:gap-4">
                {dailyReservation.Articles.map((articleDay, articleIndex) => (
                  <ArticleCard key={articleIndex} {...articleDay} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

    </div >
  );
}

export { Week };
